/**
 * C-1 — desteklenen locale'ler + yön (LTR/RTL) eşlemesi. Pilot İÇERİĞİ en/tr'dir; de + ar
 * altyapı olarak desteklenir (seçilebilir; katalog boşsa defaultMessage'a düşer). ar RTL'dir →
 * tema yönü (stylis-plugin-rtl) directionOf'tan sürülür. [STD-DRIFT: pilot content EN/TR]
 */
export const SUPPORTED_LOCALES = ['en', 'tr', 'de', 'ar'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

/**
 * The language a visitor gets when they have not chosen one — every console and the public site.
 *
 * ⚠ THIS IS NOT THE LANGUAGE THE SOURCE STRINGS ARE WRITTEN IN. The two were the same value until now
 * and reading one as the other is the mistake this pair exists to prevent: `defaultMessage` throughout
 * the repo is TURKISH (see `SOURCE_LOCALE`), while what a new visitor should SEE is English. Handing
 * react-intl this constant as its `defaultLocale` would tell it the fallback copy is English, which it
 * is not.
 */
export const DEFAULT_LOCALE: Locale = 'en';

/**
 * The language the code's own `defaultMessage` strings are written in.
 *
 * ⚠ TURKISH, AND NOT A PREFERENCE — a fact about the source. Every `formatMessage({ defaultMessage })`
 * in this repo carries Turkish copy, and the i18n gate treats `tr` as the catalogue that must be 100%
 * complete for exactly that reason. react-intl needs it to know when a missing key has been resolved by
 * falling back rather than by translation.
 */
export const SOURCE_LOCALE: Locale = 'tr';

/** RTL yazan diller — desteklenen küme dışında da tanınır (yön altyapısı ileri-uyumlu). */
const RTL_LANGUAGES = new Set(['ar', 'he', 'fa', 'ur']);

export type Direction = 'ltr' | 'rtl';

/** Bir dil etiketinin (locale) yazım yönü. Alt-etiket atılır: 'ar-EG' → 'ar' → rtl. */
export function directionOf(locale: string): Direction {
  const base = locale.toLowerCase().split('-')[0];
  return RTL_LANGUAGES.has(base) ? 'rtl' : 'ltr';
}

export function isRtl(locale: string): boolean {
  return directionOf(locale) === 'rtl';
}

/** Bir dil etiketini DESTEKLENEN bir locale'e indirger (bölge at); desteklenmiyorsa null. */
export function normalizeLocale(tag: string | null | undefined): Locale | null {
  if (!tag) {
    return null;
  }

  const base = tag.toLowerCase().split('-')[0];
  return (SUPPORTED_LOCALES as readonly string[]).includes(base) ? (base as Locale) : null;
}
